import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';
import CustomCruiseIcon from '../CustomCruiseIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white relative" style={{ isolation: 'isolate', transform: 'translateZ(0)' }}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <CustomCruiseIcon size={48} className="text-accent" />
              <span className="text-xl font-bold">Cruising Along</span>
            </div>
            <p className="text-gray-200 mb-4">
              Luxury cruise experiences tailored to your dreams. Discover the world from the comfort of the open sea.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/people/Cruising-Along/61577295965878/" className="text-white hover:text-accent transition-colors duration-300">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/cruising.along/" className="text-white hover:text-accent transition-colors duration-300">
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@cruising_along" className="text-white hover:text-accent transition-colors duration-300">
                <Youtube size={20} />
              </a>
{/*           <a href="#" className="text-white hover:text-accent transition-colors duration-300">
  *              <XIcon size={20} />
  *            </a>
  */}          </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 font-sans">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://www.cruisingalong.com" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Home</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/destinations" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Destinations</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/blog" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Blog</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/cruise-tracker" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Companion App</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/about" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">About Us</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/contact" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Contact</a>
              </li>
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h3 className="text-lg font-bold mb-4 font-sans">Popular Destinations</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://www.cruisingalong.com/destinations#caribbean" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Caribbean</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/destinations#mediterranean" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Mediterranean</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/destinations#alaska" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Alaska</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/destinations#northern-europe" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Northern Europe</a>
              </li>
              <li>
                <a href="https://www.cruisingalong.com/destinations#asia-pacific" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Asia & Pacific</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 font-sans">Ready to book your next adventure? Contact us now!</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="flex-shrink-0 mt-1" />
                <span>Orlando, FL 32806</span>
              </li>
              <li>
                <a 
                  href="tel:+14074372634"
                  className="flex items-center space-x-3 text-gray-200 hover:text-accent transition-colors duration-300 group"
                >
                  <Phone size={20} className="group-hover:text-accent transition-colors duration-300" />
                  <span>(407) 437-2634</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@cruisingalong.com"
                  className="flex items-center space-x-3 text-gray-200 hover:text-accent transition-colors duration-300 group"
                >
                  <Mail size={20} className="group-hover:text-accent transition-colors duration-300" />
                  <span>info@cruisingalong.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-primary-light">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; {currentYear} Cruising Along LLC. All rights reserved.</p>
            <div className="mt-4 md:mt-0 flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2 text-sm md:text-base">
              <a href="https://www.cruisingalong.com/privacy-policy.html" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              <a href="https://www.cruisingalong.com/booking-terms.html" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">Booking Terms &amp; Conditions</a>
              <a href="https://www.cruisingalong.com/terms-of-service.html" className="text-gray-200 hover:text-accent transition-colors duration-300" target="_blank" rel="noopener noreferrer">App Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
